import { useTranslation } from "react-i18next";
import { PhotoDisplayHandler } from "components";
import LinkLanguage from "locales/LinkLanguage";
import {
  capitalizeFirstLetter,
  truncateString,
} from "utils/helpers/strings";
import { CURRENCY } from "utils/textConstants";
import "./SearchItem.scss";

const SearchItem = ({ data, hideDropdown }: any) => {
  const { t } = useTranslation("home", { useSuspense: false });
  return (
    <LinkLanguage
      className={`Search-Article-Item`}
      to={"/article/" + data.article_slug}
      action={hideDropdown}
    >
      <div className="Search-Article-Item-First">
        <PhotoDisplayHandler
          img_name={data.background_image}
          calculate={false}
          img_class_name="Search-Article-Item-Image"
          img_alt={data.article_name}
          width="auto"
          height="80%"
        />
      </div>
      <p className="Search-Article-Item-Name">
        {truncateString(capitalizeFirstLetter(data.article_name), 35)}
      </p>
      {data.article_price.is_visible ? (
        <div className="Search-Article-Item-Price-Item">
          {data.article_price.on_sale && (
            <p className="Search-Article-Item-Old-Price">
              {data.article_price.old_price}&nbsp;{CURRENCY}
            </p>
          )}
          <p className="Search-Article-Item-Discount-Price">
            {data.article_price.price}&nbsp;{CURRENCY}
          </p>
        </div>
      ) : (
        <div className="Search-Article-Item-Price-Item">
          <p className="Search-Article-Item-Discount-Price">
            {t("cijena_na_upit")}
          </p>
        </div>
      )}
    </LinkLanguage>
  );
};
export default SearchItem;
